export default function KontaktSection() {
  return (
    <section className="bg-white py-20 px-4" id="kontakt">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-center items-start gap-x-64 gap-y-12">
        {/* Lewa kolumna: Adres + Kontakt */}
        <div className="flex flex-col gap-5 max-w-md">
          {/* Adres */}
          <div>
            <h3 className="text-2xl font-heading mb-2">Adres:</h3>
            <hr className="border-t border-gray-300 w-16 mb-4" />
            <p className="mb-2 text-gray-600">Magiczna Restauracja</p>
            <p className="mb-2 text-gray-600">43-100 Tychy</p>
            <p className="mb-4 text-gray-600">ul. Strzelecka 85</p>
          </div>

          {/* Kontakt */}
          <div>
            <h3 className="text-2xl font-heading mb-2">Kontakt:</h3>
            <hr className="border-t border-gray-300 w-16 mb-4" />
            <p className="mb-2 text-gray-600">tel. 668 291 465</p>
          </div>
        </div>

        {/* Prawa kolumna: Godziny otwarcia */}
        <div className="max-w-md">
          <h3 className="text-2xl font-heading mb-2">Godziny otwarcia:</h3>
          <hr className="border-t border-gray-300 w-16 mb-4 " />

          <p className="mb-2 text-gray-600">Poniedziałek – Piątek</p>
          <p className="mb-4 text-gray-600">12:00 – 19:00</p>

          <p className="mb-2 text-gray-600">Sobota</p>
          <p className="mb-4 text-gray-600">12:00 – 20:00</p>

          <p className="mb-2 text-gray-600 ">Niedziela</p>
          <p className="text-gray-600">12:00 – 20:00</p>
        </div>
      </div>

      {/* Mapka Google */}
      <div id="map" className="mt-12 max-w-5xl mx-auto">
        <iframe
          title="Mapa dojazdu"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2573.779819229304!2d18.974410176632527!3d50.10985037153069!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4716c4ffb3f6826d%3A0xf8000fdd389a7e4b!2sStrzelecka%2085%2C%2043-109%20Tychy!5e0!3m2!1spl!2spl!4v1716738000000"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="rounded-xl shadow-lg"
        ></iframe>
      </div>
    </section>
  );
}
